import React, { Component, Fragment } from 'react'
import CenterElement from './CenterElement'

class TitleUI extends Component {

    // componentDidMount = () => {
    //     window.x(this.txt)  
    //   }
    render = () => {
        let { activity, quizViewer } = this.props

        let { quizViwerModel } = quizViewer.state
        let { selectedStyle } = activity.activityTitle
        let { projectPlugin } = quizViwerModel


        return (
            <div className="container title-container" style={{ textAlign: "center", direction: "rtl", width: "100%" }}>

                {(quizViwerModel.currentLang == quizViwerModel.ARABIC_LANG)

                    ?
                    <Fragment>
                        <div className="row">
                            <div className="activity-num border-change" style={{ display: "inline-block", width: "60px", height: "60px", }}>

                                <CenterElement
                                    content={this.toArabicDigits(activity.activityIndex + 1 + "")}
                                    style={(selectedStyle != null) ? selectedStyle[2].style : {}}
                                    textAlign="center" />
                            </div>
                            {/* <div style={{ display: "inline-block", width: "840px", height: "60px", border: "solid 1px black", borderRadius: "4px", backgroundColor: "white", paddingRight: "40px", direction: "rtl", textAlign: "right" }}>
                                <table style={{ width: "100%", height: "100%" }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ textAlign: "right", verticalAlign: "middle" }}
                                                ref={(el) => (this.txt = el)}
                                                dangerouslySetInnerHTML={{ __html: activity.activityTitle.activityTitleAr }}
                                                onBlur={this.handleTxtChange}
                                                onInput={this.handleTxtChange}
                                                onMouseDown={this.handleMouseDown}>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> */}
                            {/* <div className="btn btn-outline-primary" style={{
                                // width: "60px", height: "60px", border: "solid 4px",
                                // borderColor: (projectPlugin != null) ? projectPlugin.appBg2Color : "black",
                                // borderRadius: "4px",
                                // display: "inline-block", marginRight: "10px", backgroundColor: "white",
                                cursor: "pointer"
                            }}
                                onClick={this.handleChangeToEn}>

                                <CenterElement
                                    content={"EN"}
                                    style={{ fontSize: "30px" }}
                                    textAlign="center" />
                            </div> */}
                        </div>
                    </Fragment>

                    :

                    <Fragment>
                        <div style={{
                            width: "60px", height: "60px", border: "solid 4px", borderColor: (projectPlugin != null) ? projectPlugin.appBg2Color : "black",
                            borderRadius: "10px", display: "inline-block", marginLeft: "10px", backgroundColor: "white", cursor: "pointer"
                        }}
                            onClick={this.handleChangeToAr}>
                            <CenterElement
                                content={"ع"}
                                style={{ fontSize: "30px" }}
                                textAlign="center" />

                        </div>

                        {/* <div style={(selectedStyle != null) ? selectedStyle[4].style : {}}>


                            <table style={{ width: "100%", height: "100%" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ textAlign: "left", verticalAlign: "middle" }}
                                            dangerouslySetInnerHTML={{ __html: activity.activityTitle.activityTitleEng }}
                                            onBlur={this.handleTxtChangeEn}
                                            onInput={this.handleTxtChangeEn}
                                            onMouseDown={this.handleMouseDown}>

                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                        <div style={(selectedStyle != null) ? selectedStyle[1].style : {}}>

                            <CenterElement
                                content={activity.activityIndex + 1}
                                style={(selectedStyle != null) ? selectedStyle[2].style : {}}
                                textAlign="center" />
                        </div> */}


                    </Fragment>

                }

            </div>
        )
    }


    toArabicDigits = (num) => {
        var id = ['۰', '۱', '۲', '۳', '٤', '٥', '٦', '۷', '۸', '۹'];
        return num.replace(/[0-9]/g, function (w) {
            return id[+w]
        });
    }

    handleChangeToEn = () => {
        let { activity, quizViewer } = this.props
        let { quizViwerModel } = quizViewer.state

        quizViwerModel.currentLang = quizViwerModel.ENGLISH_LANG
        quizViewer.setState({ quizViwerModel })

    }


    handleChangeToAr = () => {
        let { activity, quizViewer } = this.props
        let { quizViwerModel } = quizViewer.state

        quizViwerModel.currentLang = quizViwerModel.ARABIC_LANG
        quizViewer.setState({ quizViwerModel })

    }
}

export default TitleUI
